<template>
	<div
		class="container__checkbox"
		:style="style"
	>
		<input
			:id="id"
			v-model="model"
			type="checkbox"
			:disabled="disabled"
			:value="modelValue"
			class="checkbox"
			:placeholder="label"
		/>
		<label
			v-if="label"
			:for="id"
			:class="{ 'font-bold': checked }"
			class="text-[#464947]"
		>
			{{ label }}
		</label>
	</div>
</template>

<script setup>
import { computed, toRefs } from 'vue'
const emit = defineEmits(['input'])

const props = defineProps({
	label: String,
	id: {
		type: String,
		required: false,
	},
	modelValue: {
		type: [String, Boolean, Object, Number],
	},
	value: {
		type: [Boolean, Array, String],
	},
	disabled: {
		type: Boolean,
		default: false,
	},
})

const model = computed({
	get() {
		return props.value
	},
	set(value) {
		emit('input', value)
	},
})

const checked = computed(() => {
	if (props.modelValue instanceof Array) {
		return props.modelValue.includes(props.value)
	} else {
		return props.modelValue
	}
})

const { label } = toRefs(props)

const style = computed(() => {
	return props.label ? { display: 'flex', gap: '8px' } : undefined
})
</script>

<style scoped>
input[type='checkbox'] {
}

.container__checkbox {
	@apply text-sm w-fit;
}

.container__checkbox input {
	@apply accent-[#34617E] cursor-pointer;
}

.container__checkbox label {
	@apply flex items-center gap-2;
}

.container__checkbox input:disabled {
	@apply cursor-not-allowed;
}
</style>
